(function ($){
    $(document).ready(function() {
        // Remove any existing handlers first
        $('body').off('click.quantity', '.quantity__control');
        
        // Add the handler with namespace
        $('body').on('click.quantity', '.quantity__control', function (e){
            e.preventDefault();
            e.stopPropagation();
            
            let that = $(this),
                quantity = that.parents('.quantity'),
                input = quantity.find('.quantity__input'),
                val = parseFloat(input.val());

            val = val < 1 ? 1 : val;

            if(that.is('.quantity__control_minus')){
                val = val === 1 ? 1 : val - 1;
            } else {
                ++val;
            }

            input.val(val);
            
            // Trigger WooCommerce cart update
            input.trigger('change');
            
            // For WooCommerce cart page - trigger the update cart button
            if ($('button[name="update_cart"]').length > 0) {
                $('button[name="update_cart"]').prop('disabled', false).trigger('click');
            }
            
            // For AJAX cart updates (if enabled)
            if (typeof wc_cart_fragments_params !== 'undefined') {
                $(document.body).trigger('update_checkout');
                $(document.body).trigger('wc_update_cart');
            }
        });
    });
}(jQuery));